import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'

const ReservedEquipmentConfirmDialog = ({
  open,
  equipmentNumber,
  customerAlias,
  isBlocked = false,
  blockedStatus = null,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>
      {isBlocked && blockedStatus === 'reserved'
        ? 'Equipamento reservado para outro cliente'
        : isBlocked
          ? 'Equipamento alugado para outro cliente'
          : 'Equipamento já reservado para este cliente'}
    </DialogTitle>
    <DialogContent>
      <Typography>
        O equipamento <strong>{equipmentNumber}</strong>{' '}
        {isBlocked && blockedStatus === 'reserved'
          ? 'está reservado para:'
          : isBlocked
            ? 'está alugado para:'
            : 'já está reservado para:'}
      </Typography>
      <Typography fontWeight={700} color="primary.main" sx={{ mt: 1 }}>
        {customerAlias || 'Cliente não informado'}
      </Typography>
      <Typography sx={{ mt: 2 }}>
        {isBlocked && blockedStatus === 'reserved'
          ? 'Ele não pode ser adicionado ao movimento porque está reservado para outro cliente.'
          : isBlocked
            ? 'Ele não pode ser adicionado ao movimento enquanto estiver alugado para outro cliente.'
            : 'Ao continuar, ele será convertido para aluguel após a confirmação da entrega. Deseja adicioná-lo ao movimento?'}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancelar</Button>
      {!isBlocked && (
        <Button onClick={onConfirm} variant="contained" autoFocus>
          Adicionar equipamento
        </Button>
      )}
    </DialogActions>
  </Dialog>
)

export default ReservedEquipmentConfirmDialog
